import BaseModel from './BaseModel';

export default class LoginResponseModel extends BaseModel {
  init(data) {
    this.access = data.access || '';
    this.refresh = data.refresh || '';
  }
}
